
import React from 'react';
import { Container} from 'react-bootstrap';
import Gallery from '../components/gallery';


export default class Perception extends React.Component{

  constructor(props) {
    super(props);
    this.state = {listOfImages: []};
  }

  importAll(r) {
    return r.keys().map(r);
  }

  componentDidMount() {
    const listOfImages = this.importAll(require.context('../Images/perception', false, /\.(png|jpe?g|svg)$/));
    const rows = listOfImages.reduce(function (rows, key, index) { 
      return (index % 3 === 0 ? rows.push([key]) 
        : rows[rows.length-1].push(key)) && rows;
    }, []);
    this.setState({listOfImages:rows});
  }

  render(){
    return (
      <Container>
        <h1 className='text-center m-5'>Outlines of Perception</h1>
        <h4 className='text-center m-5'>A collection of drawings and poems exploring one’s inner struggles and overcomings.</h4>
        <Gallery listOfImages={this.state.listOfImages} />
      </Container>
    );
  }
}